import { render, staticRenderFns } from "./detalhe-protocolo-processo.vue?vue&type=template&id=b5b5ed8c"
import script from "./detalhe-protocolo-processo.vue?vue&type=script&lang=js"
export * from "./detalhe-protocolo-processo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports